<template>
  <div class="about-us">
    <Header />

    <main role="main">
      <AboutUsBackground />
      <AboutUsBanner />
      <AboutUsCite />
      <AboutUsTools />
      <AboutUsCompanies />
      <AboutUsTeam />
      <AboutUsInvestors />
      <AboutUsHiring />
      <AboutUsMap />
      <AboutUsMedia />
    </main>

    <Footer />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import AOS from 'aos';
import AboutUsBackground from './page-sections/AboutUsBackground.vue';
import AboutUsBanner from './page-sections/AboutUsBanner.vue';
import AboutUsCite from './page-sections/AboutUsCite.vue';
import AboutUsTools from './page-sections/AboutUsTools.vue';
import AboutUsCompanies from './page-sections/AboutUsCompanies.vue';
import AboutUsTeam from './page-sections/AboutUsTeam.vue';
import AboutUsInvestors from './page-sections/AboutUsInvestors.vue';
import AboutUsHiring from './page-sections/AboutUsHiring.vue';
import AboutUsMap from './page-sections/AboutUsMap.vue';
import AboutUsMedia from './page-sections/AboutUsMedia.vue';
import Footer from '~/components/global/Footer/Footer.vue';
import Header from '~/components/global/Header/Header.vue';

import 'aos/dist/aos.css';

export default Vue.extend({
  name: 'AboutUs',
  components: {
    Header,
    AboutUsBackground,
    AboutUsMedia,
    AboutUsMap,
    AboutUsHiring,
    AboutUsInvestors,
    AboutUsTeam,
    AboutUsCompanies,
    AboutUsTools,
    AboutUsCite,
    AboutUsBanner,
    Footer,
  },
  mounted() {
    AOS.init();
  },
});
</script>

<style lang="scss">
.about-us {
  min-height: 100vh;
  background: var(--color-text);
}
</style>
